import { Navigate, Outlet, useLocation } from 'react-router';
import React from 'react';
import { useIsCaregiverPendingApproval, useIsLoggedIn } from 'features/auth/hooks/useAuthData';
import { useCobrandedPath } from 'features/cobrand/hooks/useCobrandUtils';

export const GuestGuard: React.FC = () => {
  const isLoggedIn = useIsLoggedIn();
  const isCaregiverPendingApproval = useIsCaregiverPendingApproval();
  const location = useLocation();
  const caregiverApprovalPagePath = useCobrandedPath('/pending-approval');
  const homePagePath = useCobrandedPath('/home');

  // If caregiver is pending approval, redirect to /pending-approval
  if (isCaregiverPendingApproval) {
    return <Navigate to={caregiverApprovalPagePath} replace />;
  }

  // If user just logged in and there's a returnUrl, redirect there instead of home
  if (isLoggedIn) {
    const returnUrl = location.state?.returnUrl as string | undefined;
    const redirectTo = returnUrl || homePagePath;
    return <Navigate to={redirectTo} replace />;
  }

  return <Outlet />;
};
